import {
  IModalStep, IModalStepCommon, IModalStepCommonData,
  IModalStepData
} from './index'
import {
  ModalControlButton,
  IModalControlButton,
  IModalControlButtonData
} from '../index'


export class ModalStepCommon implements IModalStepCommon {
  readonly name: string
  readonly icon: string
  readonly silent: boolean

  constructor(data: IModalStepCommonData) {
    this.name = data.name
    this.icon = data.icon || this.name.toLowerCase()
    this.silent = !!data.silent
  }
}

export class ModalStep extends ModalStepCommon implements IModalStep {
  readonly controls: IModalControlButton[]
  readonly close?: Function
  loading: boolean

  constructor(data: IModalStepData) {
    super(data)
    let controls = data.controls
    if (!(controls && controls.length)) {
      controls = [
        { type: 'ok' }
      ];
    }
    this.close = data.close
    this.controls = controls.map((control: IModalControlButtonData) => new ModalControlButton(control));
    this.loading = false;
  }

  validate(): boolean {
    return true
  }
}
